// Note: The first file of a module here, must also register the module

import "./prospector-form.component";
import "./prospector-change-state-dialog.component";
import "./prospector-add-on-dialog.component";
